import { render, staticRenderFns } from "./CollapsiblePane.vue?vue&type=template&id=41e24bae&"
import script from "./CollapsiblePane.vue?vue&type=script&lang=ts&"
export * from "./CollapsiblePane.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsiblePane.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports